var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalcFigureVolumeCylinder(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 250 250",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "Artboard1",
    x: 0,
    y: 0,
    width: 250,
    height: 250,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Artboard11"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(5.22837e-17,0.853857,-0.245851,1.5054e-17,109.828,64.388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.439,106.4L27.439,121.324L15.98,101.425L27.439,81.527L27.439,96.451L155.973,96.451L155.973,81.527L167.431,101.425L155.973,121.324L155.973,106.4L27.439,106.4Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.349046,-1.2326e-32,0,0.245851,91.0273,58.2512)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.011,106.4L44.011,121.324L15.98,101.425L44.011,81.527L44.011,96.451L167.431,96.451L167.431,81.527L167.431,121.324L167.431,106.4L44.011,106.4Z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.967528,0,0,0.967528,-11.0346,110.276)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "78.3px",
    y: "36.332px",
    style: {
      fontFamily: "'AndaleMono', 'Andale Mono', monospace",
      fontSize: "18.119px"
    }
  }, "h")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.967528,0,0,0.967528,43.4218,43.1421)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "78.3px",
    y: "36.332px",
    style: {
      fontFamily: "'AndaleMono', 'Andale Mono', monospace",
      fontSize: "18.119px"
    }
  }, "r")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.967528,0,0,0.967528,68.4339,110.276)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "78.3px",
    y: "36.332px",
    style: {
      fontFamily: "'AndaleMono', 'Andale Mono', monospace",
      fontSize: "18.119px"
    }
  }, "V")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.17474,0,0,1,-9.12189,53.3504)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 135,
    cy: 147.5,
    rx: 45,
    ry: 22.5,
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "3.67px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.17474,0,0,1,-9.12189,-64.3133)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 135,
    cy: 147.5,
    rx: 45,
    ry: 22.5,
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "3.67px"
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,9.46853,23.3504)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.137,177.5L87.137,60",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: 4
    }
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,115.195,24.6004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M87.137,177.5L87.137,60",
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: 4
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalcFigureVolumeCylinder);
export default __webpack_public_path__ + "static/media/calc-figure-volume-cylinder.4c04c6d1a79c4cf67e68cfc83737468a.svg";
export { ForwardRef as ReactComponent };